import React, { useState } from "react";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { AddTicket } from "../../services/ticket/ticket";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
function Ticket() {
  const navigate = useNavigate()
  const [title, setTitle] = useState("");
  const [priority, setPriority] = useState("");
  const [description, setDescription] = useState("");
  const [attachment, setAttachment] = useState(null);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append("idUser", Number(0)); // Replace 1 with actual user ID
    formData.append("title", title);
    formData.append("type", Number(priority));
    formData.append("comment", description);
    formData.append("file", attachment || "");
    formData.append("pathfile", "");

  
    try {
      await AddTicket(formData);
      navigate("/support")
      // Optional: clear form or show success message
    } catch (error) {
      console.error("Error submitting ticket:", error);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      py: 4,
      px:0,
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          backgroundColor: "#F4F2FB",
          p: 3,
          borderRadius: 3,
          color: "black",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "600px",
          gap: 2,
        }}
      >
        <Typography variant="h6" fontWeight="bold" mb={1}>
          {t("Support.Ticket")}
        </Typography>

        <TextField
          required
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          label={t("Support.Title")}
          fullWidth
        />

        <FormControl fullWidth required>
          <InputLabel id="priority-label">{t("Support.Severity")}</InputLabel>
          <Select
            labelId="priority-label"
            value={priority}
            label={t("Support.Severity")}
            onChange={(e) => setPriority(e.target.value)}
          >
            <MenuItem value={4}>{t("Support.Low")}</MenuItem>
            <MenuItem value={3}>{t("Support.Moderate")}</MenuItem>
            <MenuItem value={2}>{t("Support.Urgent")}</MenuItem>
            <MenuItem value={1}>{t("Support.Critical")}</MenuItem>
          </Select>
        </FormControl>

        <TextField
          required
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          label={t("Support.Text")}
          multiline
          rows={5}
        />

        <Button
          variant="outlined"
          component="label"
          sx={{ alignSelf: "flex-start" }}
          endIcon={<AttachFileIcon/>}

        >
         {t("Support.Attach")}
          <input
            type="file"
            hidden
            onChange={(e) => setAttachment(e.target.files[0])}
          />
        </Button>
        {attachment && (
          <Typography variant="body2" color="text.secondary">
            {attachment.name}
          </Typography>
        )}

        <Button
          type="submit"
          variant="contained"
          color="secondary"
          sx={{ borderRadius: "100px", py: 1.2, fontSize: "16px", mt: 2 }}
        >
          {t("Support.Send")}
        </Button>
      </Box>
    </Box>
  );
}

export default Ticket;
